import { UserProfile } from '../../interfaces/User/User'
import { SET_USER_PROFILE } from '../types/userProfileActionsTypes'

export type UserProfileAction = UserProfilesAction

// Esto va a REDUX
export interface UserProfilesAction {
  type: typeof SET_USER_PROFILE
  userProfile: UserProfile
}

export const setUserProfilesAction = (
  userProfile: UserProfile
): UserProfileAction => {
  return {
    type: SET_USER_PROFILE,
    userProfile
  }
}
